import { Requirements } from 'app/routes';

import { UserFilterType } from 'store/models/user';
import { setUser, setUserId, UserDetail } from 'store/models/userDetail';

export const UserDetailRequirements: Requirements<{ userDetail: UserDetail[] }> = {
    methods: ({ match }) => ({
        userDetail: {
            url: `/api/v1/backoffice/users/?type=${UserFilterType.UserId}&value=${match?.params.userId || ''}`,
            cacheable: false,
        },
    }),
    resolve: ({ result: { userDetail }, match }) => {
        return [setUser(userDetail[0]), setUserId(match?.params.userId || '')];
    },
};
